import React, {  useEffect } from 'react';
import { Table, Input, Select } from 'antd';
import "./Table.css"
import moment from 'moment';

const expandedRowRender = (record: any) => {
    // console.log('OPEN RECORD REECORD: ', record);
    
    const columns: any = [
      { 
        title: '#', 
        dataIndex: 'index', 
        key: 'index',
        render: (text: any, record: any, index: number) => index + 1, 
      },
      { 
        title: 'Medication Status', 
        dataIndex: 'medication_status', 
        key: 'medication_status' ,
        render: (text: any, record: any, index: number) => record?.medication_status ? 'True' : 'False', 
      },
      {
        title: 'Activity Status', 
        dataIndex: 'activity_status', 
        key: 'activity_status' ,
        render: (text: any, record: any, index: number) => {
          let value = '';
          
          if(record?.activity_status > 0) {
            value = 'Vigorous (Running)';
          }else if(record?.activity_status == 0) {
            value = 'Moderate (Walking)'
          }else {
            value = 'None'
          }

          return <span>{value}</span>;
        }, 
      },
      {
        title: 'Value', 
        dataIndex: 'xvalue', 
        key: 'xvalue' 
      },
      { 
        title: 'Action', 
        key: '', 
        dataIndex: "",
        render: () => <a >View Graph</a> },
    ];

    return <Table key={record.id}   className="custom-table" columns={columns} dataSource={record?.readings} pagination={false} />;
  };

function DataTable({ data, setActiveCasetData, toggleAddReadingModal }: any) {
    const columns: any= [
        { 
          title: '#', 
          dataIndex: 'index', 
          key: 'index',
          render: (text: any, record: any, index: number) => index + 1,
        },
        {
          title: 'Patient Name', 
          dataIndex: 'patientName', 
          key: 'patientName', 
          render: (name: any) => (name ? name : '--'), 
        },
        {
          title: 'Patient Phone', 
          dataIndex: 'phoneNumber', 
          key: 'phoneNumber',
          render: (phone: any) => (phone ? phone : '--'),  
        },
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            sorter: (a: any, b: any) => a.name.localeCompare(b.name),
          },
          {
            title: 'Label',
            dataIndex: 'label',
            key: 'label',
            sorter: (a: any, b: any) => a.label.localeCompare(b.label),
          },
          {
            title: 'Case Code',
            dataIndex: 'CID',
            key: 'CID',
            sorter: (a: any, b: any) => a.CID.localeCompare(b.CID),
          },
          {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            sorter: (a: any, b: any) => a.CID.localeCompare(b.CID),
          },
        { 
            title: 'Date Created', 
            dataIndex: 'createdAt', 
            key: 'createdAt',
            sorter: (a: any, b: any) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
            render: (createdAt: any) => (createdAt ? createdAt?.seconds ? moment.unix(createdAt.seconds).format('MMMM D, YYYY') : moment(new Date(createdAt)).format('MMMM D, YYYY') : '--'), 
        },
        { title: 'Action', key: 'operation', render: (text: any, record: any, index: number) => <a onClick={() => {
          setActiveCasetData(record)
          toggleAddReadingModal()
        }}>Add Reading</a> },
      ];
  
      
 
    return (
        <Table
            columns={columns}
            expandable={{ expandedRowRender, defaultExpandedRowKeys: ['0'] }}
            dataSource={data.map((item: any, index: any) => ({ ...item, index: index + 1 }))}
      />
    );
}

export default DataTable;